module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-18.cc46563b.jpg";